<template>
  <div :class="open ? 'faq open' : 'faq'" @click="toggleOpen(index)">
    <div class="question" :class="open?'activeTab':''">{{ faq.title }}<i class="fa pull-right" :class="
     open ? 'fa-angle-up' : 'fa-angle-down'
      "></i></div>
    <div class="answer">{{ faq.description }}</div>
  </div>

</template>

<script>
  export default {
    name: 'FAQ',
    props: ['faq', 'index', 'open'],
    methods: {
      toggleOpen(value) {
        this.$emit('toggleOpen', value)
      }
    }
  }
</script>
<style scope>
  .activeTab {
    color: #5f57ea
  }
</style>